import { Injectable } from '@angular/core';

import { ILanguagePicker } from '../../_shared/models/language-picker/language-picker.model';
import { ILink } from '../../_shared/models/link.model';
import { IUtilityTab, UtilityTabName } from '../../_shared/models/navigation/navigation-hub.model';

/**
 * Bridge for the sibling-element navigation layout: `sirius-utility-bar` and
 * `sirius-navigation` are mounted as independent elements (separate custom
 * elements on the manuals pages, separate wrapper components in the app) with
 * no parent/child binding between them. The utility bar writes its resolved
 * data here so `NavigationMenuMobileComponent` (rendered inside navigation)
 * can read the same snapshot when it builds the mobile drawer tree.
 *
 * Callers read a one-off snapshot when they need it, so plain properties suffice.
 */
@Injectable({
    providedIn: 'root',
})
export class UtilityBarService {
    globalLinks: ILink[] = [];
    languages?: ILanguagePicker;
    activeTab: UtilityTabName = 'main';
    navigationTabs: IUtilityTab[] = [];
}
